import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonPrintIcon } from "components/ButtonPrintIcon/ButtonPrintIcon";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import DatePicker from "components/DatePicker/DatePicker";
import { FileInput } from "components/FileInput/FileInput";
import { KeyWord } from "components/KeyWord/KeyWord";
import { LetterSubject } from "components/LetterSubject/LetterSubject";
import { Loading } from "components/Loading/loading";
import { Position } from "components/Position/Position";
import { ReceiverPosition } from "components/ReceiverPosition/ReceiverPosition";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { addToIndicator, getDataForPrint, getLetter, getLetterByReferenceId, getSecretariatNo, loadAttachmentViewerBase64 } from "pages/Secretariats/LettersPage/api/api";
import { useEffect, useRef, useState } from "react";
import { LetterType, MessageType } from "types/enum";
import { GUID_EMPTY, ICON_TYPE } from "utils/constants";
import { GetReportWithJsonData, trans } from "utils/helpers";
import { getSecretariat } from "../../../ReserveForm/api";
import { IndicatorNoDictionary } from "./IndicatorNoDictionary/IndicatorNoDictionary";
import { Fileviewer } from 'components/Fileviewer/Fileviewer';
import { EnumerationTypeSelect } from 'components/EnumerationTypeSelect/EnumerationTypeSelect';
import { DictionarySelectBox } from 'components/DictionaryTypeSelect/DictionaryTypeSelect';
import { ENDPOINTS } from 'utils/endpoints';



interface LetterInformationFormPropsType {
    onHide: () => void;
    getInformation: (data,image ,method ,Indicator ) => void;
    changeSecretariatId: (SecretariatId) => void;
    setReceiver: (receiver) => void;
    changeTab: (tabName) => void;
    setLetterId: (id) => void;
    letterId:string;
    mode:any;
    type:any;
    step?:any,
    receiver?:any,
    referenceId?:any,
    Id?:any,
    jobId?:any,
    inTab?:any,
    editInIndicator?:any,
    buttonPrintObjCallBack?:any

}
export const LetterInformationForm = ({
    onHide,
    getInformation,
    changeSecretariatId,
    setReceiver,
    changeTab,
    setLetterId,
    letterId ,
    type ,
    mode,
    receiver,
    step=2,
    referenceId,
    Id,  
    jobId,  
    inTab,
    editInIndicator,buttonPrintObjCallBack

}:LetterInformationFormPropsType) => {  
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(mode==="create");
  const [letter, setLetter] = useState<any>(null);
  const [response, setResponse] = useState<any>(null);
  const [letterReceivers, setLetterReceivers] = useState<any>(null);
  const [selectedImage, setSelectedImage] = useState<any>();
  const [selectedImage64, setSelectedImage64] = useState<any>();
  const formRef = useRef(null)
  const [RegisterTime, setRegisterTime] = useState<any>();
  const [letterDate, setLetterDate] = useState<any>();
  const [indicator, setIndicator] = useState<any>();
  const [hasSendAttachment, setHasSendAttachment] = useState<any>(false);
  const [secretariatId, setSecretariatId] = useState<any>();
  const [secretariatNo, setSecretariatNo] = useState<any>();
  const [showstep, setShowstep] = useState<any>({3:true});
  const [keyWords, setKeyWords] = useState<any>([]);
  const [indicatorNo, setIndicatorNo] = useState<any>();
  const [singleIndicator, setSingleIndicator] = useState<any>(null);
  const [userChanges, setUserChanges] = useState({});
  const [letterTextMode,setLetterTextMode] = useState(true)
  const [editor, setEditor] = useState<any>();
  const [editorData, setEditorData] = useState<any>();
  const [htmlString, sethtmlString] = useState<any>(null);
  const [showAloneAttach, setShowAloneAttach] = useState(false);
  const [load, setLoad] = useState<any>();
  const [fileName, setFileName] = useState< any>();
  const svgRef = useRef<any>(null);
  const orderRef1 = useRef<any>(null);

 

  async function loadAttachmentViewerAsync(e) {
    try {
        const res:any = await loadAttachmentViewerBase64(e );
        setLoad(res);
        setFileName("Attachment.png");
      //  document.getElementById("DashboardLayout")?.insertAdjacentHTML("afterbegin", '<div id="backScreen" style="z-index:100 !important" class="fullScreen" ></div>')

        setShowAloneAttach(true)
        return res

    } catch (error) {
        setLoad(" ")
        return " "
    }

}


  const LetterSubmit = (event) => {
    event.preventDefault();
    if(!selectedImage&&mode=="create"&&type == "Incoming"){Toast("Msg_AttachmentIsRequired",MessageType.error); return false }
    setShowstep({1:false , 2:false,3:false})
    if (mode === "create" || letter == null ) { 
        if(type !== "Incoming"){
          let Letter:any = {
            LetterType: +LetterType[type.trim()],
            LetterNo:  event?.target?.LetterNo?.value,
            LetterSecurity:  +event.target.LetterSecurity.value,
            LetterUrgency:  +event.target.LetterUrgency.value,
            LetterSubject: event.target.LetterSubject.value,
            SenderPositionId: event.target.Sender.value.includes("-") ? event.target.Sender.value : null,
            SenderDescription: event.target.Sender.value,
            LetterText: letterTextMode ?   event.target.LetterText.value :  editorData,
          }
          getInformation(Letter , selectedImage?.File ,"post",null)
        }else{
          let Letter:any = {
            LetterType: +LetterType[type.trim()],
            LetterSecurity:  +event.target.LetterSecurity.value,
            LetterUrgency:  +event.target.LetterUrgency.value,
            LetterSubject: event.target.LetterSubject.value,
            SenderPositionId:  event.target.Sender.value.includes("-") ? event.target.Sender.value : null,
            SenderDescription: event.target.Sender.value,
            LetterText: letterTextMode ?   event.target.LetterText.value :  editorData,
            LetterNo: event?.target?.LetterNo?.value,
            LetterDate: event?.target?.letterDate?.value ,

          }

          let Indicator:any={
            LetterType: +LetterType[type.trim()] ,
            SecretariatId: event.target.Secretariat.value,
            IndicatorStatic:  `${indicatorNo.Value}`?.slice(0, -1*(indicatorNo.Id.length)),
            IndicatorSerial:+indicatorNo.Id,
            Description:event.target.Description.value,
            SendAttachmentDescription:event.target?.SendAttachmentDescription?.value ? event.target?.SendAttachmentDescription?.value : "",
            HasSendAttachment:event.target.HasSendAttachment.value == "true",
            Keywords:keyWords.join(",")
     
          }
          getInformation(Letter , selectedImage.File ,"post",Indicator)
          }
    }else{
      if(step ==2 || editInIndicator){
      if(indicator && indicator?.Id){
        let Indicator:any={
          Id  : indicator.Id,
          LetterType  : indicator.LetterType,
          Description:event.target.Description.value,
          SendAttachmentDescription:event.target.HasSendAttachment.value == "true" ? event.target.SendAttachmentDescription.value :"",
          HasSendAttachment:event.target.HasSendAttachment.value == "true",
          Keywords:keyWords?.join(",")
        }
        addToIndicatorAsync(Indicator  , "put" )

      }else{
        let Indicator:any={
          letterId : letterId ,
          SecretariatId: event.target.Secretariat.value,
          IndicatorStatic:  `${indicatorNo.Value}`?.slice(0, -1*(indicatorNo.Id.length)),
          IndicatorSerial:+indicatorNo.Id,
          LetterType: +LetterType[type.trim()] ,
          Description:event.target.Description.value,
          SendAttachmentDescription:event.target?.SendAttachmentDescription?.value,
          HasSendAttachment:event.target.HasSendAttachment.value == "true",
          Keywords:keyWords?.join(",")
        }
        addToIndicatorAsync(Indicator  ,"post")
      }
      }else{

        if(type !== "Incoming"){

          let Letter:any = {
            Id : letterId ,
            LetterType: letter.LetterType,
            LetterNo:  event?.target?.LetterNo?.value,
            LetterSecurity:  +event.target.LetterSecurity.value,
            LetterUrgency:  +event.target.LetterUrgency.value,
            LetterSubject: event.target.LetterSubject.value,
            SenderPositionId:  event.target.Sender.value.includes("-") ? event.target.Sender.value : null,
            SenderDescription: event.target.Sender.value,
            LetterText: letterTextMode ?   event.target.LetterText.value :  editorData,
                    }
          getInformation(Letter , selectedImage?.File ,"put",null)
        }else{
          let Letter:any = {
            Id : letterId ,
            LetterType: +LetterType[type.trim()],
            LetterSecurity:  +event.target.LetterSecurity.value,
            LetterUrgency:  +event.target.LetterUrgency.value,
            LetterSubject: event.target.LetterSubject.value,
            SenderPositionId:  event.target.Sender.value.includes("-") ? event.target.Sender.value : null,
            SenderDescription: event.target.Sender.value,
            LetterText: letterTextMode ?   event.target.LetterText.value :  editorData,
            LetterNo: event?.target?.LetterNo?.value,
            LetterDate: event?.target?.letterDate?.value ,
          }
          let Indicator:any={
            letterId : letterId ,
            SecretariatId: event.target.Secretariat.value,
            IndicatorStatic:  indicator.IndicatorStatic,
            IndicatorSerial:indicator.IndicatorSerial,
            SendAttachmentDescription:indicator.SendAttachmentDescription,
            HasSendAttachment:indicator.HasSendAttachment,
            LetterType: indicator.LetterType ,
            Id:indicator.Id,
            RegisterTime:RegisterTime,
            Description:event.target.Description.value,
            Keywords:keyWords.join(",")
          }
          getInformation(Letter , selectedImage.File ,"put",Indicator)
          }
      }
    }
}

const changeHandlePic = (e: any) => {
   if (e.target.files && e.target.files.length > 0) {
     getBase64([...e.target.files][0])
     setSelectedImage({Url: URL.createObjectURL([...e.target.files][0] )   ,File:[...e.target.files][0]});
   }
};

async function getLetterAsync(id) {
  setLoading(false)
  try {
     const res = await getLetter(id);    
     setResponse(res.Data)
     setLetterTextMode(!res.Data.Letter.LetterText.includes("<")) 
 if(res.Data?.Letter.Id && res.Data?.Letter.Id!=GUID_EMPTY &&res.Data.Indicator&&res.Data.Indicator?.Id&&res.Data.Letter?.LetterType!=LetterType.Incoming){
        if(orderRef1.current!=null){

          buttonPrintObjCallBack&& buttonPrintObjCallBack({
          Id: res.Data?.Letter.Id ,
          reportDomain:"",
          objectTag:`${type}LetterInformationForm`,
          apiFunction:getDataForPrint
        })}
      }else{
        buttonPrintObjCallBack&& buttonPrintObjCallBack(null) 
      }
     setEditorData(res.Data.Letter.LetterText)
     setLetter(res.Data.Letter)
     setLetterId(res.Data.Letter.Id)
     setIndicator(res.Data.Indicator)
     console.log(res.Data.Indicator,'pppp');
     
     setHasSendAttachment(res.Data.Indicator.HasSendAttachment)
     setKeyWords(res.Data?.Indicator?.Keywords?res.Data?.Indicator?.Keywords.split(","):[])
     setLetterDate(res.Data.Letter.LetterDate)
     if(res.Data.LetterReceivers){
      if(res.Data.LetterReceivers[0].PositionId ){
        
        setLetterReceivers(res.Data.LetterReceivers[0].PositionId )
      }else if(res.Data.LetterReceivers.GroupPositionId ){
       
        setLetterReceivers(res.Data.LetterReceivers[0].GroupPositionId )
      }
     }
     if(editInIndicator){
       setShowstep({1:true , 2:false})
     }
     
  } catch (error) {
      
  }
  setLoading(true)
}
async function getLetterByReferenceIdAsync() {
  setLoading(false)
  try {
    const res = await getLetterByReferenceId(referenceId);    
  setResponse(res.Data)
   if(res.Data?.Letter.Id && res.Data?.Letter.Id!=GUID_EMPTY&&res.Data.Indicator&&res.Data.Indicator?.Id&&res.Data.Letter?.LetterType!=LetterType.Incoming){
         if(orderRef1.current!=null){

          buttonPrintObjCallBack&& buttonPrintObjCallBack({
          Id: res.Data?.Letter.Id ,
          reportDomain:"",
          objectTag:`${type}LetterInformationForm`,
          apiFunction:getDataForPrint
        })
      }
      }else{
        buttonPrintObjCallBack&& buttonPrintObjCallBack(null) 
      }
  setLetterTextMode(!res.Data.Letter.LetterText.includes("<"))
  setEditorData(res.Data.Letter.LetterText)
  setLetter(res.Data.Letter)
  setLetterId(res.Data.Letter.Id)
  setKeyWords(res.Data?.Indicator?.Keywords?res.Data?.Indicator?.Keywords?.split(","):[])
  setLetterDate(res.Data.Letter.LetterDate)
  setIndicator(res.Data?.Indicator)
  setHasSendAttachment(res.Data?.Indicator?.HasSendAttachment)
  if(res.Data.Letter.LetterType == LetterType.Incoming&&res.Data.LetterDefaultAttachmentId){
    loadAttachmentViewerAsync(res.Data.LetterDefaultAttachmentId)
  }

  if((res.Data.Indicator==null) &&  (!res.Data?.Indicator?.Id) && mode=="edit"){
    if(step==1){
      setShowstep({1:false , 2:true})
      
    }else{
      setShowstep({1:false , 2:false})
    }
  }
  if(res.Data.LetterReceivers){
    if(res.Data.LetterReceivers[0].PositionId ){
      setLetterReceivers(res.Data.LetterReceivers[0].PositionId )
    }else if(res.Data.LetterReceivers[0].GroupPositionId ){
      setLetterReceivers(res.Data.LetterReceivers[0].GroupPositionId )
    }
  }
} catch (error) {
  
  }
  setLoading(true)
}

function getBase64(file) {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    setSelectedImage64(reader.result)
  };
  reader.onerror = function (error) {
  };
}

async function getSecretariatNoAsync(letterId) {
  try {
     const res = await getSecretariatNo(letterId ,singleIndicator ? 0 : LetterType[type.trim()]); 
     setSecretariatNo(res.data ) 
  } catch (error) {
      
  }
}
async function addToIndicatorAsync(Indicator , method) {
  try {
     const res = await addToIndicator(Indicator ,method); 
     sessionStorage.setItem("changingforms" , "false");
     setUserChanges({});
     onHide()
  } catch (error) {
      
  }
}

async function getSecretariatAsync(key,obj) {
  try {
   //  const res = await getSecretariat(id ); 
     setSingleIndicator(obj?.SingleIndicator)
     setSecretariatId(obj?.Id)
  } catch (error) {
      
  }
}

const handleBeforeUnload = (event) => {
  event.preventDefault();
  event.returnValue = '';
};



 


useEffect(() => {
  if(Object.values(userChanges).filter((item)=>item!=null).length>0){
      sessionStorage.setItem("changingforms" , "true")
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
  }else{
      sessionStorage.setItem("changingforms" , "false")
      window.removeEventListener('beforeunload', handleBeforeUnload);

  }
}, [userChanges]);

useEffect( () => {
    if(Id&& mode != "create" && inTab === "LetterForm"){
      getLetterAsync(Id)

    }else if(referenceId&& mode !== "create" && inTab === "LetterForm"){
      getLetterByReferenceIdAsync()

    }
    if(step > 1 ||type === "Incoming" || (mode!="create" &&indicator?.SecretariatId!= null )){


    }
}, [Id ,referenceId, mode ,inTab]);

useEffect( () => {
    if(secretariatId ){
      getSecretariatNoAsync(secretariatId)
    }
}, [secretariatId]);



  return (
        <div ref={orderRef1}>
          {htmlString&&
                <div ref={svgRef} dangerouslySetInnerHTML={{ __html: htmlString }} style={{  width:"690px"}} />
          }
          {showAloneAttach&&
              <div className="" style={{position:"fixed" ,right:"2%" , top:"7%" ,width: "100%",zIndex:"901"}}>
              <FontAwesomeIcon onClick={()=>{setShowAloneAttach(false);document.getElementById("backScreen")?.remove()}}  size="3x" color='white' icon={['fas', 'times']} style={{zIndex:"9999" , cursor: 'pointer' , position:"absolute" }} />
              <div style={{display: "flex" , height: "92vh", justifyContent:"center" ,zIndex:"901"}} className='w-100'>
                <Fileviewer File={fileName } showDownLoad={false} src={load} showArchive={true} showFile={false} />
              </div>          
              </div>
  
            } 
          {loading ?
            <div className="pt">
              {/* {(indicator&&indicator.Id&&letter.LetterType!=LetterType.Incoming)&&
                <div className="row " style={{flexDirection: "row-reverse" , marginTop:"-5px"}}>
          {mode!=='create' && <ButtonPrintIcon reportDomain={"OfficeAutomation"}  objectTag={"LetterForm"} Callback={(e) => {getDataForPrintAsync(e)}} />}
                </div>
              
              } */}
              <form ref={formRef} onInvalid={()=>{changeTab("LetterForm")}} id="InformationForm" onSubmit={LetterSubmit} className={"conta iner " +mode}>
                              <div className={`${(step > 1||type === "Incoming") && "card"}`}>
                               
                              {(step > 1||type === "Incoming" || (mode!="create" &&indicator?.SecretariatId!= null )) &&
                                  <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px", justifyContent: "space-between" }} className="d-flex  py-1 col-12 pr-4">
                                        <div>{trans("step")}-1 </div>
                                      <div style={{ marginLeft: "18px" }} onClick={() => { showstep[1] ? setShowstep({ ...showstep, 1: false }) : setShowstep({ ...showstep, 1: true }) }} >{showstep[1] ? <FontAwesomeIcon icon={[ICON_TYPE, "angle-down"]} size="lg" className="icon" /> : <FontAwesomeIcon icon={[ICON_TYPE, "angle-up"]} size="lg" className="icon" />}</div>
                                  </div>
                              }
                              <div style={{display: !showstep[1] ?"block" :"none"}} className="card-body">
                                  <div className="row my-1">
                                    {(type ||letter?.LetterType )&&
                                      <div className="col-12 my-1 my-lg-0 col-lg-2">
                                       <Textbox  
                                          textboxType="text"
                                          textboxName="letterType"
                                          resetForm={resetForm}
                                          defaultValue={type ?  trans(type.trim()) :trans( LetterType[letter.LetterType])}
                                          labelText="letterType"
                                          mode={"view"}
                                        />
                                      </div>                                   
                                    }
                                    {type === "Incoming" && 
                                    <>
                                     <div className="col-12 my-1 my-lg-0 col-lg-2">
                                        <DatePicker
                                            Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                            lable='LetterDate'
                                            resetForm={resetForm}
                                            required={true}
                                            setIsoTime={(isoTime: string) => { setLetterDate(isoTime) }}
                                            val={letter?.LetterDate }
                                            mode={step > 1 ? "view" : mode}
                                          />
                                      </div>
                                      <div className="col-12 my-1 my-lg-0 col-lg-2">
                                         <Textbox
                                              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                              textboxType="text"
                                              textboxName="LetterNo"
                                              resetForm={resetForm}
                                              required={true}
                                              defaultValue={letter?.LetterNo ?letter?.LetterNo : ""}
                                              labelText="LetterNo"
                                              mode={step > 1 ? "view" : mode}
                                            />
                                      </div>                                    
                                    </>
                                      }
                                    <div className="col-12 my-1 my-lg-0 col-lg-2">
                                        <EnumerationTypeSelect
                                        Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                        mode={step > 1 ? "view" : mode}
                                        name="LetterSecurity"
                                        value={letter?.LetterSecurity ?letter?.LetterSecurity : ""}
                                        enumTypeSelect='LetterSecurity'
                                        label='LetterSecurity'
                                        />                              
                                    </div>
                                    <div className="col-12 my-1 my-lg-0 col-lg-2">
                                        <EnumerationTypeSelect
                                        Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                        mode={step > 1 ? "view" : mode}
                                        name="LetterUrgency"
                                        value={letter?.LetterUrgency ?letter?.LetterUrgency : ""}
                                        enumTypeSelect='LetterUrgency'
                                        label='LetterUrgency'
                                        />                              
                                    </div>

                                        {type === "Incoming" && 
                                          <div className=" col-2 mt-3 pt-3 my-lg-0 col-lg-1">
                                              <CheckableButton
                                                  Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                                  onchange={(checked,e)=>{ setReceiver({...receiver ,IsCopy:checked})}  }
                                                  defaultValue={1}
                                                  type='checkbox'
                                                  labelText='IsCopy'
                                                  defaultChecked={ false}
                                                  inputName='IsCopy'
                                                  mode={mode}
                                              />
                                          </div>
                                      }
                               
                                  <div className="col-12 my-1 my-lg-0 col-lg-6">
                                        <LetterSubject
                                        Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                        label={"LetterSubject"}
                                        mode={step > 1 ? "view" : mode}
                                        required={true}
                                        name="LetterSubject"
                                        value={letter?.LetterSubject ?letter?.LetterSubject : ""}
                                        />                              
                                    </div>

                                    <div className={`col-12 my-1 my-lg-0 ${type === "Incoming" ?"col-lg-3": "col-lg-6"} `}>
                                         <Position
                                            allowType={true}
                                            Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                            required
                                            label="Sender"
                                            name="Sender"
                                            returnObj={true}
                                            resetForm={resetForm}
                                            valueString={letter?.SenderPositionId?null :letter?.SenderDescription }

                                            value={ letter?.SenderPositionId ?letter?.SenderPositionId : "" }
                                            mode={step > 1 ? "view" : mode}
                                            />                                          
                                    </div>
                                    <div className={`col-12 my-1 my-lg-0 ${type === "Incoming" ?"col-lg-3": "col-lg-6"} `}>
                                         <ReceiverPosition
                                         allowType={true}
                                              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                              required={type != "Incoming"}
                                              returnObj={true}
                                              onChange={(e)=>{ setReceiver({...receiver,Id:e.Id ,Name:e.Name   })}  }
                                              label="Addressee"
                                              name="Receiver"
                                              resetForm={resetForm}
                                              valueString={letterReceivers?null :response?.LetterReceivers?.[0]?.ReceiverDescription }
                                              value={letterReceivers ? letterReceivers :(letter?.LetterReceivers?.[0].PositionId ?letter?.LetterReceivers?.[0].PositionId :letter?.LetterReceivers?.[0].GroupPositionId ) }
                                              mode={step > 1 ? "view" : mode}
                                              />
                                     </div>
                                  </div>
                                  <div className={mode!="view"?"card":""}>
                                    {type == "Incoming"&&

                                  <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px", justifyContent: "space-between" }} className="d-flex  py-1 col-12 pr-4">
                                        <div>{trans("text")}</div>
                                      <div style={{ marginLeft: "18px" }} onClick={() => { showstep[3] ? setShowstep({ ...showstep, 3: false }) : setShowstep({ ...showstep, 3: true }) }} >{showstep[3] ? <FontAwesomeIcon icon={[ICON_TYPE, "angle-down"]} size="lg" className="icon" /> : <FontAwesomeIcon icon={[ICON_TYPE, "angle-up"]} size="lg" className="icon" />}</div>
                                  </div>
                                    }
                              <div style={{display: (!showstep[3]||type != "Incoming") ?"block" :"none"}} className={mode!="view"?"card-body":""}>
                                    {(mode!="view")&&
                                    <div className="col-md-6 col-12">

                                    <CheckableButton
                                      onchange={setLetterTextMode}
                                      type='checkradio'
                                      labelText={trans("Editor")+" "+trans("Simple")}
                                      labelFalseText={trans("Editor")+" "+trans("Advanced")}
                                      defaultChecked={letterTextMode }
                                      checked={letterTextMode }
                                      inputName='letterTextMode'
                                      mode={mode}
                                      />  
                                      </div>
                                    
                                    }
                                  <div className="col-12">
                                     {!letterTextMode ? 
                                     <div>
                                     
                                     <CKEditor

                                       data={editorData}
                           disabled={mode == "view" && "true"}
                           onReady={editor => {
                               editor.ui.getEditableElement().parentElement.insertBefore(
                                   editor.ui.view.toolbar.element,
                                   editor.ui.getEditableElement()
                               );
                               setEditor(editor)
                           }}
                           onError={(error, { willEditorRestart }) => {
                               if (willEditorRestart) {
                                   editor.ui.view.toolbar.element.remove();
                               }
                           }}
                           onOk={(editor) => {
                               editor.insertHtml(editorData)
                           }}
                           onChange={(event, editor) => {
                               const data = editor.getData();
                               setEditorData(data)
                           }}
                           editor={DecoupledEditor}
                           config={{
                               fontFamily: {
                                   options: [
                                       'default',
                                       'Ubuntu, Arial, sans-serif',
                                       ' Vazir, Vazir, Vazir',
                                       ' IRANSans, IRANSans, IRANSans',
                                       'B Zar, Arial,  sans-serif',
                                       'Ubuntu Mono, Courier New, Courier, monospace'
                                   ]
                               },
                               contentsLangDirection : 'rtl',
                               removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                               placeholderProps: {
                                 types: ["First Name", "Date"],
                               },
                               placeholderBrackets: {
                                 open: "{",
                                 close: "}",
                               }
                               
                                       }}
                                        />
                                     </div>

                                     :
                                  <Textbox
                                      Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                      minHeight={5}
                                      textboxType="textarea"
                                      textboxName="LetterText"
                                      resetForm={resetForm}
                                      defaultValue={letter?.LetterText ?letter?.LetterText : ""}
                                      labelText="LetterText"
                                      mode={step > 1 ? "view" : mode}
                                  /> 
                                     }
                                  </div>
                                      {
                                        
                                
                                      }

                                      </div>

                                  </div>
                                  <div className="col-3">
                                          <FileInput
                                            showBox={true}
                                            maxWidth={1000}
                                            maxHeight={1000}
                                            maxSize={25600000}
                                            defultFileName="defaultAttachment.jpg"
                                           // file={selectedImage ? {fileName:selectedImage.name, src:selectedImage64} : null}
                                            hideSrc={selectedImage ?false :false}
                                            required={type != "Incoming"}
                                            endpoint={ENDPOINTS.secretariat.indicator.attachmentFile}
                                            id={response?.LetterDefaultAttachmentId}
                                            mode={(step > 1||mode=="edit") ? "view" : mode}
                                            lable="LetterImage"
                                            name="defaultAttachment"
                                            onChange={changeHandlePic}
                                            src={selectedImage  ? (selectedImage.Url) : (response?.LetterDefaultAttachmentThumbnail ? 'data:image/jpg;base64,' + response?.LetterDefaultAttachmentThumbnail : '')}
                                          />
                                      </div>
                                 </div>
                              </div>
                                  {(step > 1 ||type === "Incoming" || (mode!="create" &&indicator?.SecretariatId!= null )) &&
                                 <div className="card">
                                      <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px" , justifyContent:"space-between" }} className="d-flex  py-1 col-12 pr-4"> 
                                          <div>{trans("step")}-2 </div> 
                                          <div style={{marginLeft:"18px"}}  onClick={()=>{showstep[2]?setShowstep({...showstep , 2:false}):setShowstep({...showstep , 2:true}) }}>{showstep[2] ? <FontAwesomeIcon icon={[ICON_TYPE, "angle-down"]} size="lg" className="icon" />:<FontAwesomeIcon icon={[ICON_TYPE, "angle-up"]} size="lg" className="icon" />}</div>
                                      </div>
                                      <div style={{display: !showstep[2] ?"block" :"none"}} className="card-body">
                                            <div className="row  mb-1" >
                                            <div className={`col`}>
                                                <DictionarySelectBox
                                                  keyForDictionary={'Name'}
                                                  onChange={(e,obj) =>getSecretariatAsync(e,obj)}
                                                  Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                                  label ="Secretariat"
                                                  mode={indicator?"view" : mode}
                                                  name="Secretariat"
                                                  value={indicator?.SecretariatId ?indicator?.SecretariatId : ""}
                                                  endPoint={
                                                   indicator ||mode=='view'?ENDPOINTS.secretariat.secretariat.DictionaryId:
                                                  ENDPOINTS.secretariat.secretariat.dictionary  
                                                  }
                                                  params={ indicator?.SecretariatId ||mode=='view'?{id:indicator?.SecretariatId}:null}
                                                />  
                                              </div>
                                              {(secretariatId && singleIndicator!=null) && 
                                                <div className={`col`}>
                                                  <IndicatorNoDictionary
                                                    Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                                    letterType={type ?  LetterType[type.trim()] : LetterType[letter.LetterType]}
                                                    value={""}
                                                    required={true}
                                                    mode={indicator?"view" : mode}
                                                    setIndicatorNoDictionary={setIndicatorNo}
                                                    secretariatId={secretariatId}
                                                    defaultObj={indicator? {[indicator.IndicatorSerial]:indicator.IndicatorStatic+indicator.IndicatorSerial}  :secretariatNo}
                                                  />
                                                </div>
                                               }
                                              {(indicator && indicator.RegisterTime)&& 
                                                  <div className="col my-1 my-lg-0 ">
                                                  <DatePicker
                                                      lable='RegisterTime'
                                                      resetForm={resetForm}
                                                      setIsoTime={(isoTime: string) => {setRegisterTime(isoTime) }}
                                                      val={indicator?.RegisterTime }
                                                      mode={"view"}
                                                    />
                                                </div>
                                              }
                                             </div>

                                            <div className="row">
                                              <div className="col-6">
                                                <Textbox
                                                    required={true}
                                                    minHeight={3}
                                                    Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                                    textboxType="textarea"
                                                    textboxName="Description"
                                                    resetForm={resetForm}
                                                    defaultValue={indicator?.Description ?indicator?.Description : ""}
                                                    labelText="Description"
                                                    mode={editInIndicator ? "edit"  : mode}
                                                    />
                                              </div>
                                              <div className="col">
                                               <KeyWord
                                                Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                                recordedData={indicator?.Keywords?indicator?.Keywords.split(","):[]}
                                                setKeyWords={setKeyWords}
                                                keyWords={keyWords}
                                                mode={editInIndicator ? "edit"  : mode}
                                                name="KeyWords"
                                               />
                                              </div>
                                              </div>
                                            <div className="row">
                                              <div className="col-6">
                                            <div className="col-8 mt-3">
                                              <CheckableButton
                                                  Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                                  onchange={(bol,e)=>{setHasSendAttachment(bol)}}
                                                  title={trans("HasSendAttachment")}
                                                  defaultValue={indicator?.HasSendAttachment}
                                                  defaultChecked={indicator?.HasSendAttachment}
                                                  labelText={trans("has")}
                                                  labelFalseText={trans("hasnot")}
                                                  inputName={"HasSendAttachment"}
                                                  type="checkradio"
                                                  mode={indicator?"view" : mode}
                                                  />    
                                              </div>
                                              </div>
                                            {hasSendAttachment&& 
                                              <div className="col-6">
                                                <Textbox
                                                    Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                                    minHeight={3}
                                                    textboxType="textarea"
                                                    textboxName="SendAttachmentDescription"
                                                    resetForm={resetForm}
                                                    defaultValue={indicator?.SendAttachmentDescription ?indicator?.SendAttachmentDescription : ""}
                                                    labelText="SendAttachmentDescription"
                                                    mode={indicator?"view" : mode}
                                                    />
                                              </div>
                                              }

                                              </div>
                                              
                                      </div>
                                  </div>
                                  }
              </form>
            </div>
            : 
            <Loading/>
          }
        </div>

              
  
  );
};
